
import { IMAGE_SOURCE_PATH } from "../../../setup/config/env";
import params from "../../../setup/config/params.json";
import { defaultImage } from '../../common/Sidebar';
import ManageUsers from "../ManageAdminUsers";
export function getImageSource(image = defaultImage) {
    return `${IMAGE_SOURCE_PATH}${image}`;
}

const routes = {
    teams: {
        path: "/teams",
        component: ManageUsers,
        auth: true,
        role: params.user.roles.admin.key,
        module: 'utilities',
        subModule: 'teams',
        action: 'canView',
    }
};

export default routes;